import { Component, OnInit, ChangeDetectorRef, OnDestroy, ViewChild  } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import {
  UsersService,
  CompanyService,
  DeactivatedUsersService
} from 'app/services';
import { Company, Profile } from 'app/models';
import { Subject } from 'rxjs';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteDialogComponent } from '../../dialogs';
import { ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import * as tableHelpers from 'app/helpers/tableSelectionHelpers';
import { MatSort } from '@angular/material/sort';


@Component({
  standalone: false,
  selector: 'app-blocked-users',
  templateUrl: './blocked-users.component.html',
  styleUrls: ['./blocked-users.component.scss']
})
export class BlockedUsersComponent implements OnInit, OnDestroy {
  usersError: string;
  companyId: string;
  blockedUsers: [];
  currentPageBlockedUsers: Profile[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  blockedUsersDataSource =  new MatTableDataSource([]);
  selection = new SelectionModel<Profile>(true, []);
  public company: Company;
  private onDestroy$ = new Subject<void>();
  public companyInitials: string;
  displayedColumns = [
    'select',
    'name',
    'email',
  ];
  public noRecordFound = false;
  public loading = false;
  message = 'No_blocked_user_found';
  constructor(
    public _usersService: UsersService,
    private changeDet: ChangeDetectorRef,
    private _companyService: CompanyService,
    private _deactivatedUsersService: DeactivatedUsersService,
    private _translateService: TranslateService,
    private _dialog: MatDialog,
    private _route: ActivatedRoute,
    public _location: Location
  ) {}

  ngOnInit() {
    this.companyId = this._route.snapshot.params.id;
    this.subscribeToUsers();
    this.getUsers(this.companyId);
    this.subscribeTocompany();
    this.getCompany(this.companyId);
  }

  ngOnDestroy() {
    this.changeDet.detach(); // do this
    this.onDestroy$.next();
  }
  isAllSelected = () => tableHelpers.isAllSelected(this.currentPageBlockedUsers, this.selection.selected);

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle = () => tableHelpers.masterToggle(this.currentPageBlockedUsers, this.selection);

  isPartiallySelected = () => tableHelpers.isPartiallySelected(this.currentPageBlockedUsers, this.selection.selected);

  getUsers(companyId) {
    this._usersService.getUsersByCompanyId(this.companyId, false);
  }
  subscribeToUsers() {
    this._usersService.inactiveCompanyUsers$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(users => {
        this.selection.clear();
        if (users.length > 0) {
          this.noRecordFound = false;
          users.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
          this.blockedUsers = users;
        } else {
          this.blockedUsers = [];
          this.noRecordFound = true;
        }
        this.blockedUsersDataSource.data = users;
        this.blockedUsersDataSource.paginator = this.paginator;
        this.blockedUsersDataSource.sort = this.sort;
        this.blockedUsersDataSource.sortingDataAccessor = tableHelpers.sortingDataAccessor;
        this.blockedUsersDataSource
        .connect()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((branches) => {
          this.currentPageBlockedUsers = branches;
        });
        this.changeDet.detectChanges();
      });
    this._usersService.error$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(error => {
        this.usersError = error;
        this._usersService.loading = false;
      });
  }
  getCompany(companyId) {
    this._companyService.getCompany(companyId, true);
  }
  subscribeTocompany(): void {
    this._companyService.company$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(company => {
        this.company = company;
        if (this.company) {
          this._parseName();
        }
        this.changeDet.detectChanges();
      });
    this._companyService.error$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(error => {
        this.usersError = error;
      });
  }

  private _parseName() {
    if (!this.company.name) {
      return;
    }
    this.companyInitials = `${this.company.name[0].toUpperCase()}${this.company.name[
      this.company.name.length - 1
    ].toUpperCase()}`;
  }

  deleteUser() {
    //deleteUsers
    let title;
    this._translateService
      .get('COMPANY_DELETE_USERS.delete_users_confirmation')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(value => (title = value));

    if (this.selection.selected.length === 0 || this.selection.selected.findIndex(user => user['isInvite']) !== -1) {
      return;
    } 

    const dialog = this._dialog.open(ConfirmDeleteDialogComponent, {
      disableClose: true,
      autoFocus: false,
      data: {
        users: this.selection.selected,
        title
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (result) {
        const userIds = this.selection.selected.map(user => user.id);
        this._deactivatedUsersService.permanentDelete(userIds, this.companyId);
        this.selection.clear();
      }
    });
  }

  unblockUser() {
    let title;
    this._translateService
      .get('COMPANY_DELETE_USERS.reactivate_users_confirmation')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(value => (title = value));
    if (this.selection.selected.length === 0 || this.selection.selected.findIndex(user => user['isInvite']) !== -1) {
      return;
    } 
    let unblockUser='';
    this._translateService
      .get('UnBlock_User')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(value => (unblockUser = value));
    const dialog = this._dialog.open(ConfirmDeleteDialogComponent, {
      disableClose: true,
      autoFocus: false,
      data: {
        users: this.selection.selected,
        buttonText: unblockUser,
        primaryColor: true,
        title
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (result) {
        const userIds = this.selection.selected.map(user => user.id);
        this._deactivatedUsersService.reactivateUser(
          userIds,
          this.company.companyId
        );
      this.selection.clear();
      }
    });
  }
}
